module.exports = __webpack_public_path__ + "img/p1.b40e7203.png";